export const CENTER_TEXT_MAX_LENGTH = 100;

export const TEXT_FONT_SIZE_MIN = 32;
export const TEXT_FONT_SIZE_MAX = 420;
export const TEXT_FONT_SIZE_STEP = 1;

const DISALLOWED_SCRIPT =
  /\p{Script=Cyrillic}|\p{Script=Greek}|\p{Script=Arabic}|\p{Script=Hebrew}|\p{Script=Han}|\p{Script=Hiragana}|\p{Script=Katakana}|\p{Script=Hangul}|\p{Script=Thai}|\p{Script=Devanagari}/u;

function isAllowedCenterChar(ch: string): boolean {
  const cp = ch.codePointAt(0)!;
  if (ch === "\n" || ch === "\r") return true;
  if (cp < 32 && ch !== "\n" && ch !== "\r") return false;
  if (/\p{Extended_Pictographic}/u.test(ch)) return false;
  if (DISALLOWED_SCRIPT.test(ch)) return false;
  if (/\p{Script=Latin}|\p{Script=Common}|\p{Script=Inherited}/u.test(ch)) return true;
  return false;
}

export function sanitizeCenterTextInput(raw: string): string {
  const filtered = [...raw].filter(isAllowedCenterChar).join("");
  return filtered.slice(0, CENTER_TEXT_MAX_LENGTH);
}

export function clampTextFontSize(px: number): number {
  const n = Math.round(px);
  return Math.min(TEXT_FONT_SIZE_MAX, Math.max(TEXT_FONT_SIZE_MIN, n));
}
